function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
const defaultFetch = typeof window !== "undefined" ? window.fetch : undefined;
export class RuntimeServiceHelper {
    liveURL(fileId) {
        return `${this.env.services["@superwall-editor/runtime"].baseURL}/live/document/${fileId}`;
    }
    storeURL(fileId) {
        return `${this.env.services["@superwall-editor/runtime"].baseURL}/store/document/${fileId}`;
    }
    storeAndGetURL(fileId) {
        var _this = this;
        return _async_to_generator(function*() {
            if (_this.env.services["@superwall-editor/runtime"].baseURL.includes("/dev/dev")) {
                return _this.liveURL(fileId);
            }
            // We're going to load the store url & get the redirect
            const url = _this.storeURL(fileId);
            console.log("Fetching store url", url);
            const headers = yield _this.fetch(url, {
                redirect: "manual"
            }).then((res)=>res.headers);
            console.log("Got store url", headers);
            if (!headers || !headers.get("location")) {
                throw new Error("Failed to get store url");
            }
            return headers.get("location");
        })();
    }
    constructor(env, fetch = defaultFetch){
        _define_property(this, "env", void 0);
        _define_property(this, "fetch", void 0);
        this.env = env;
        this.fetch = fetch;
    }
}
export class EditorServiceHelper {
    editorURL({ paywallId, applicationId, version = "latest" }) {
        if (this.env.services["@superwall-editor/editor"].baseURL.includes("/dev/dev")) {
            return `${this.env.services["@superwall-editor/editor"].baseURL}/#/applications/${applicationId}/paywalls/${paywallId}/${version}`;
        }
        // When we're in production we'll send
        // `/editor/#/applications/5/paywalls/28/latest`
        return `/editor/#/applications/${applicationId}/paywalls/${paywallId}/${version}`;
    }
    constructor(env){
        _define_property(this, "env", void 0);
        this.env = env;
    }
}
